module.exports = __webpack_public_path__ + "static/drumster-web-min-0b3e0d4b416fc19602ff042d114bf524.jpg";